if (!customElements.get('m-localization-form')) {
  class t extends HTMLElement {
    constructor() {
      super()
      const t = this.querySelector('[data-localization-select]')
      t &&
        t.addEventListener('change', (e) => {
          const a = e.target.value,
            o = t.closest('[data-localization-form]'),
            l = o.querySelector('input[data-localization-input]')
          l && l.setAttribute('value', a), l && o.submit()
        })
    }
  }
  customElements.define('m-localization-form', t)
}
